import { MatSnackBar } from '@angular/material/snack-bar';
import { Attachment } from './../../../models/attachment.model';
import { BasicRegister } from 'src/app/models/basic-register.model';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MgService } from 'src/app/services/mg.service';
import { Call } from 'src/app/models/call.model';
import { Item } from 'src/app/models/item.model';

@Component({
  selector: 'app-call-complete',
  templateUrl: './call-complete.component.html',
  styleUrls: ['./call-complete.component.scss']
})
export class CallCompleteComponent implements OnInit {
  public call: Call = new Call();

  constructor(
    private route: ActivatedRoute,
    private api: MgService,
    private _snackBar: MatSnackBar,
  ) { }

  ngOnInit(): void {
    this.loadCallInfo()
  }

  private loadCallInfo() {
    this.api.getCallByIdentifier(this.identifier)
      .subscribe(
        res => {
          this.call = res.data
        },
        err => {
          console.error(err)
        }
      )
  }

  public get identifier(): string {
    return this.route.snapshot.params['identifier']
  }

  public newEntry(entry: Item) {
    this.call.items.push(entry);
  }

  public newFiles(any: boolean) {
    this.loadCallInfo();
  }

  public setBusiness(business: BasicRegister) {
    this.api.setCallBusiness(this.call.identifier, business.id)
      .subscribe(
        res => {
          this.call.business_id = business.id;
          this.call.business = business;
        }
      )

    let  businessUser = this.call.business_user;
    if(!this.call.business_user.business_id) {
      businessUser.business_id = business.id;

      this.api.storeBusinessUser(businessUser)
      .subscribe(
        res => {
          this._snackBar.open('Chamado atribuído com Sucesso', 'Fechar', {
            duration: 3000,
          });
        }
      )
    }
  }
}
